





































import Api from "./Api";
import {Component, Inject} from "vue-property-decorator";
import {DateTime, PhonelistReportRow, UnverifiedCompany} from "../../../modules/models";
import Routes from "../../../modules/Routes";
import CompanyUserRequired from "../../CompanyRequired";

@Component
export default class PhonelistReport extends CompanyUserRequired {
    @Inject()
    api!: Api;

    loading = false;
    items: PhonelistReportRow[] = [];

    async loadResult() {
        this.loading = true;
        try {
            this.items = await this.api.fetchPhonelistReport(this.company.orgNum);
        } catch (err) {
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    headers = [
        {text: "Fornavn", value: "firstName", align: "left"},
        {text: "Etternavn", value: "lastName", align: "left"},
        {text: "Født", value: "birthDate", align: "left"},
        {text: "Telefon", value: "phone", align: "left"},
        {text: "Firma", value: "companies", align: "left"},
    ];

    companiesToCompanyNames(companies: UnverifiedCompany[]) {
        return companies.map((c) => c.name).join(", ");
    }

    formatDate(dt: DateTime): string | null {
        return dt != null ? dt.toLocalDate() : null;
    }

    get distinctCompanies() {
        const ret: UnverifiedCompany[] = [];
        for(let i of this.items) {
            for(let c of i.companies) {
                if(c.orgNum != null && c.name != null && c.name.length > 0 && ret.indexOf(c) == -1) {
                    ret.push(c);
                }
            }
        }
        return ret;
    }

    filterOrgNums: number[] = [];

    get filteredItems() {
        if(this.filterOrgNums.length == 0) {
            return this.items;
        } else {
            return this.items.filter((i) => i.companies.some((c) => c.orgNum != null && this.filterOrgNums.indexOf(c.orgNum) > -1 ));
        }
    }

    get excelReportUrl() {
        return Routes.phonelistReportXlsx(this.company.orgNum, this.filterOrgNums);
    }

    created() {
        this.loadResult();
    }
}
